/**
 * razorpayOptions — v146.36
 *
 * Razorpay's checkout SDK validates several `options` fields against a
 * strict allow-list regex. Any character outside that list triggers the
 * generic "The string did not match the expected pattern." error at
 * modal open, which blocks the user from paying. This module wraps the
 * fields callers commonly pass so we sanitise once and every caller
 * stays safe by construction.
 */

/** Collapse to Razorpay-safe printable ASCII, cap the length. */
export function cleanText(v, max = 240) {
  return (v || "")
    .toString()
    .replace(/[^A-Za-z0-9 .,'’&()/\-_:;!?]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, max);
}

/** Keep only digits; return the last 10 (drops +91 / country prefix). */
export function cleanPhone(v) {
  return (v || "").toString().replace(/[^0-9]/g, "").slice(-10);
}

/** Keep only email-safe chars, cap length. */
export function cleanEmail(v) {
  return (v || "").toString().trim().slice(0, 120);
}

/**
 * Sanitise the full `prefill` block in one call.
 * Missing fields collapse to empty strings so Razorpay doesn't
 * complain about undefined values either.
 */
export function cleanPrefill({ name, email, contact } = {}) {
  return {
    name: cleanText(name, 60),
    email: cleanEmail(email),
    contact: cleanPhone(contact),
  };
}
